export const CheckboxButtonSelected = () => {
  return (
    <svg
      className={`svg-icon me-1`}
      style={{
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        fontSize: '20px'
      }}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M799 161c16.954 0 32.986 6.696 45.145 18.855C856.304 192.014 863 208.046 863 225v574c0 16.954-6.696 32.986-18.855 45.145C831.986 856.304 815.954 863 799 863H225c-16.954 0-32.986-6.696-45.145-18.855C167.696 831.986 161 815.954 161 799V225c0-16.954 6.696-32.986 18.855-45.145C192.014 167.696 208.046 161 225 161h574m0-64H225c-70.4 0-128 57.6-128 128v574c0 70.4 57.6 128 128 128h574c70.4 0 128-57.6 128-128V225c0-70.4-57.6-128-128-128z" />
      <path d="M726.505 361.495c-12.445-12.445-32.81-12.445-45.255 0L448.005 594.74 342.75 489.485c-12.445-12.445-32.81-12.445-45.255 0s-12.445 32.81 0 45.255L425.26 662.505c7.827 7.827 18.786 10.727 28.938 8.709a31.76 31.76 0 0 0 16.611-8.768L726.505 406.75c12.445-12.445 12.445-32.81 0-45.255z" />
    </svg>
  )
}

export const CheckboxButtonUnselected = () => {
  return (
    <svg
      className={`svg-icon me-1`}
      style={{
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        fontSize: '20px'
      }}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M799 161c16.954 0 32.986 6.696 45.145 18.855C856.304 192.014 863 208.046 863 225v574c0 16.954-6.696 32.986-18.855 45.145C831.986 856.304 815.954 863 799 863H225c-16.954 0-32.986-6.696-45.145-18.855C167.696 831.986 161 815.954 161 799V225c0-16.954 6.696-32.986 18.855-45.145C192.014 167.696 208.046 161 225 161h574m0-64H225c-70.4 0-128 57.6-128 128v574c0 70.4 57.6 128 128 128h574c70.4 0 128-57.6 128-128V225c0-70.4-57.6-128-128-128z" />
    </svg>
  )
}
